import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { color, fontTypeToObject } from '@starrez/starryui9';

interface ITextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    invalid?: boolean;
}

export const TextInput = forwardRef<HTMLInputElement, ITextInputProps>(({ invalid, ...props }, ref) => (
    <Input ref={ref} type="text" aria-invalid={invalid} {...props} />
));

const Input = styled.input`
    height: 40px;
    width: 100%;
    border: 1px solid ${color.Grey.G30};
    background-color: white;
    border-radius: 4px;
    text-indent: 12px;
    padding: 0;
    box-sizing: border-box;
    ${() => ({ ...fontTypeToObject('normal.regular') })}

    &[focus] {
        border-color: ${color.Blue.B60};
        outline: none;
    }

    &[aria-invalid='true'] {
        border-color: ${color.Red.R60};
    }

    &[disabled] {
        opacity: 0.4;
    }
`;
